import { createRouter, createWebHistory } from "vue-router";
import { isRouteEnabled } from "@/utils/planUtils";
import ClientesList from "../Pages/ClientesList.vue";
import ProveedoresList from "../Pages/ProveedoresList.vue";
import EmpleadoList from "@/Pages/EmpleadoList.vue";
import CategoriasList from "@/Pages/CategoriasList.vue";
import unidadMedidaList from "@/Pages/unidadMedidaList.vue";
import ProductosList from "@/Pages/ProductosList.vue";
import LoginList from "@/Pages/LoginList.vue";
import RegistroList from "@/Pages/RegistroList.vue";
import VentasList from "@/Pages/VentasList.vue";
import ComprasList from "@/Pages/ComprasList.vue";
import HomeList from "@/Pages/HomeList.vue";
import ReporteVentasList from "@/Pages/ReportesVentasList.vue";
import AdministrarVentas from "@/Pages/AdministrarVentas.vue";
import AdministrarCompras from "@/Pages/AdministrarCompras.vue";
import SucursalesList from "@/Pages/SucursalesList.vue";
import PromocionesProductos from "@/Pages/PromocionesProductos.vue";
import PromocionesCategorias from "@/Pages/PromocionesCategorias.vue";
import ConfigPage from "@/Pages/ConfigPage.vue";
import ConfigCompany from "@/Pages/ConfigCompany.vue";
import ConfigSar from "@/Pages/configSar.vue";
import AdministrarInventario from "@/Pages/AlertasInventario.vue";
import CuentasPorCobrar from "@/Pages/CuentasPorCobrar.vue";
import CotizacionesPage from "@/Pages/CotizacionesPage.vue";
import ArqueoCajaPage from "@/Pages/ArqueoCajaPage.vue";
import CuentasPorPagar from "@/Pages/CuentasPorPagar.vue";
import DevolucionesPage from "@/Pages/DevolucionesPage.vue";
import NominaPage from "@/Pages/NominaPage.vue";
import LibrosFiscalesPage from "@/Pages/LibrosFiscalesPage.vue";
import DocumentacionPage from "@/Pages/DocumentacionPage.vue";
import AuditoriaPage from "@/Pages/AuditoriaPage.vue";
import ProduccionPage from "@/Pages/ProduccionPage.vue";
import PrimerAcceso  from "@/Pages/PrimerAcceso.vue";
import PlanVencido   from "@/Pages/PlanVencido.vue";
import MiCuenta      from "@/Pages/MiCuenta.vue";
import ProformaPage  from "@/Pages/ProformaPage.vue";

// Función para obtener el rol desde localStorage
function getRole() {
  return localStorage.getItem("role");
}

/*
1: Admin
2: Gerente
3: Cajero
4: CEO
*/

const routes = [
  {
    path: "/administrar-compras",
    name: "AdministrarCompras",
    component: AdministrarCompras,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/administrar-ventas",
    name: "AdministrarVentas",
    component: AdministrarVentas,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: LoginList,
  },
  {
    path: "/primer-acceso",
    name: "PrimerAcceso",
    component: PrimerAcceso,
    meta: { requiresAuth: true },
  },
  {
    path: "/plan-vencido",
    name: "PlanVencido",
    component: PlanVencido,
    meta: { requiresAuth: true },
  },
  {
    path: "/mi-cuenta",
    name: "MiCuenta",
    component: MiCuenta,
    meta: { requiresAuth: true, role: [4] }, // Solo CEO
  },
  {
    path: "/proforma",
    name: "Proforma",
    component: ProformaPage,
    meta: { requiresAuth: true, role: [4] }, // Solo CEO
  },
  {
    path: "/home",
    name: "Home",
    component: HomeList,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
  path: "/cuentas-por-cobrar",
  name: "CuentasPorCobrar", 
  component: CuentasPorCobrar,
  meta: { requiresAuth: true, role: [1,4] }, // Solo admin
},
  {
    path: "/clientes",
    name: "Clientes",
    component: ClientesList,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/reporte",
    name: "reporte",
    component: ReporteVentasList,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/sucursales",
    name: "Sucursales",
    component: SucursalesList,
    meta: { requiresAuth: true, role: [4] },
  },
  {
    path: "/proveedores",
    name: "Proveedores",
    component: ProveedoresList,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/empleados",
    name: "Empleados",
    component: EmpleadoList,
    meta: { requiresAuth: true, role: [1, 4] },
  },
  {
    path: "/categorias",
    name: "Categorias",
    component: CategoriasList,
    meta: { requiresAuth: true, role: [1, 4] },
  },
  {
    path: "/unidad-medida",
    name: "Unidad-Medida",
    component: unidadMedidaList,
    meta: { requiresAuth: true, role: [1, 4] },
  },
  {
    path: "/productos",
    name: "Productos",
    component: ProductosList,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/registro",
    name: "Registro",
    component: RegistroList,
  },
  {
    path: "/compras",
    name: "Compras",
    component: ComprasList,
    meta: { requiresAuth: true, role: [1, 2] },
  },
  {
    path: "/ventas",
    name: "Ventas",
    component: VentasList,
    meta: { requiresAuth: true, role: [1, 3, 4] },
  },
  {
    path: "/promociones-producto",
    name: "Promociones-producto",
    component: PromocionesProductos,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/promociones-categorias",
    name: "Promociones-categorias",
    component: PromocionesCategorias,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/config-page",
    name: "Config-page",
    component: ConfigPage,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/config-company",
    name: "Config-company",
    component: ConfigCompany,
    meta: { requiresAuth: true, role: [1, 4] },
  },
  {
    path: "/config-sar",
    name: "Config-sar",
    component: ConfigSar,
    meta: { requiresAuth: true, role: [1] },
  },
  {
    path: "/admin-invenario",
    name: "Admin-inventario",
    component: AdministrarInventario,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/cotizaciones",
    name: "Cotizaciones",
    component: CotizacionesPage,
    meta: { requiresAuth: true, role: [1, 2, 3, 4] },
  },
  {
    path: "/arqueo-caja",
    name: "ArqueoCaja",
    component: ArqueoCajaPage,
    meta: { requiresAuth: true, role: [1, 2, 3, 4] },
  },
  {
    path: "/cuentas-por-pagar",
    name: "CuentasPorPagar",
    component: CuentasPorPagar,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/devoluciones",
    name: "Devoluciones",
    component: DevolucionesPage,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/nomina",
    name: "Nomina",
    component: NominaPage,
    meta: { requiresAuth: true, role: [1, 4] },
  },
  {
    path: "/libros-fiscales",
    name: "LibrosFiscales",
    component: LibrosFiscalesPage,
    meta: { requiresAuth: true, role: [1, 4] },
  },
  {
    path: "/documentacion",
    name: "Documentacion",
    component: DocumentacionPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/auditoria",
    name: "Auditoria",
    component: AuditoriaPage,
    meta: { requiresAuth: true, role: [1, 4] },
  },
  {
    path: "/produccion",
    name: "Produccion",
    component: ProduccionPage,
    meta: { requiresAuth: true, role: [1, 2, 4] },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: () => {  // Removido el parámetro 'to' ya que no se usa
      const isAuthenticated = Boolean(localStorage.getItem("auth"));
      const role = getRole();
      
      if (!isAuthenticated) return '/login';
      return role === '3' ? '/ventas' : '/home';
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = Boolean(localStorage.getItem("auth"));
  const role = getRole();


  // Si el usuario está autenticado e intenta acceder al login
  if (to.path === '/login' && isAuthenticated) {
    if (role === '3') {
      return next('/ventas');
    }
    return next('/home');
  }

  // Si intenta acceder a la ruta raíz estando autenticado
  if (to.path === '/' && isAuthenticated) {
    if (role === '3') {
      return next('/ventas');
    }
    return next('/home');
  }

  // Permitir acceso a reset-password sin autenticación
  if (to.path === "/reset") {
    return next();
  }

  // Si la ruta requiere autenticación y el usuario no está autenticado
  if (to.matched.some((record) => record.meta.requiresAuth) && !isAuthenticated) {
    return next("/login");
  }

  // ── Guard de plan vencido ──────────────────────────────────────────────────
  // Rutas que siempre están permitidas (independiente del vencimiento)
  const RUTAS_LIBRES = ['/login', '/plan-vencido', '/primer-acceso', '/registro', '/reset', '/mi-cuenta', '/proforma'];
  const comprobantePendiente = localStorage.getItem('comprobante_pendiente') === '1';

  // Si hay comprobante en revisión y el usuario trata de ir a /plan-vencido → redirigir al app
  // (ya pagó, no tiene sentido mostrarle la pantalla de bloqueo)
  const estadoSuscActual = localStorage.getItem('estado_suscripcion');

  // Estados que indican un pago activo en revisión — bypass del chequeo de fecha
  const ESTADOS_PAGO_REVISION = ['pago_en_revision', 'aprobado_autenticidad'];
  // Estados que NO deben ver /plan-vencido (empresa operando normalmente o en revisión)
  // 'proforma_activa' = trial día 10-15: proforma disponible pero acceso permitido
  const ESTADOS_SIN_BLOQUEO  = [...ESTADOS_PAGO_REVISION, 'activa', 'trial', 'proforma_activa'];

  // Si la empresa opera normalmente y trata de ir a /plan-vencido → redirigir al app
  const tieneComprobanteActivoGlobal = comprobantePendiente ||
    ESTADOS_SIN_BLOQUEO.includes(estadoSuscActual);
  if (isAuthenticated && to.path === '/plan-vencido' && tieneComprobanteActivoGlobal) {
    const destino = role === '3' ? '/ventas' : '/home';
    return next(destino);
  }

  if (isAuthenticated && !RUTAS_LIBRES.includes(to.path)) {
    const estadoSusc = localStorage.getItem('estado_suscripcion');

    // Bloqueo explícito por mora o inconsistencia → plan-vencido inmediato
    const ESTADOS_BLOQUEADOS = ['bloqueada_mora', 'bloqueada_revision', 'prueba_vencida'];
    if (ESTADOS_BLOQUEADOS.includes(estadoSusc)) {
      return next('/plan-vencido');
    }

    // Si hay comprobante en revisión activa → dejar pasar (backend también lo valida)
    const tieneComprobanteActivo = comprobantePendiente ||
      ESTADOS_PAGO_REVISION.includes(estadoSusc);

    if (!tieneComprobanteActivo) {
      // Verificar si empresa de pago superó los 5 días de gracia
      const fvStr = localStorage.getItem('fecha_vencimiento');
      if (fvStr) {
        const partes = String(fvStr).substring(0, 10).split('-').map(Number);
        const fechaBloqueo = new Date(partes[0], partes[1] - 1, partes[2] + 5);
        if (new Date() >= fechaBloqueo) {
          return next('/plan-vencido');
        }
      }
    }
  }

  // Si la ruta tiene roles definidos y el rol del usuario no tiene acceso
  if (
    to.matched.some((record) => record.meta.role) &&
    !to.meta.role?.includes(Number(role))
  ) {
    if (role === '3') {
      return next('/ventas');
    }
    return next("/home");
  }

  // Si el usuario está autenticado y trata de acceder a una ruta no existente
  if (to.matched.length === 0 && isAuthenticated) {
    if (role === '3') {
      return next('/ventas');
    }
    return next('/home');
  }

  // Bloquear rutas deshabilitadas por el plan de la empresa
  if (isAuthenticated && !isRouteEnabled(to.path)) {
    return next(role === '3' ? '/ventas' : '/home');
  }

  next();
});

// Manejar el evento popstate (botones atrás/adelante del navegador)
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    const isAuthenticated = Boolean(localStorage.getItem("auth"));
    const role = getRole();

    if (isAuthenticated) {
      const currentPath = window.location.pathname;
      if (currentPath === '/login' || currentPath === '/') {
        if (role === '3') {
          router.push('/ventas');
        } else {
          router.push('/home');
        }
      }
    }
  });
}

export default router;